import { useContext } from "react";
import { AuthContext } from "../auth-context";

export default function Restricted(props: {
  to?: string;
  children: React.ReactNode;
}): React.ReactNode {
  const authenticationContext = useContext(AuthContext)!;
  const isAllowed = authenticationContext.isAuthorized(props.to);

  if (isAllowed) {
    return props.children;
  }
  return;
}
